import axios from 'axios';
import {url} from '../../../utils/urls';

const withCredentials = true;

export const getSiteConfiguration = ({siteUUID, accountUUID, siteURL}) =>
  axios.get(`${url.asu.pubPortal.sites}/${siteUUID}/article-sentiment-units/configurations?accountUUID=${accountUUID}&siteURL=${siteURL}`, {withCredentials});

export const setSiteConfiguration = ({
  configurationUUID,
  title,
  enableOverview,
  overviewTimeRange,
  enablePageId,
  colorConfiguration: {
    background,
    primaryText,
    secondaryText,
    branding,
  }
}) =>
  axios.put(`${url.asu.pubPortal.articleSentimentUnits}/configurations/${configurationUUID}`, {
      title,
      enableOverview,
      overviewTimeRange,
      enablePageId,
      colorConfiguration: {
        background,
        primaryText,
        secondaryText,
        branding,
      }
    },
    {withCredentials}
  )

export const getCodeForSite = siteUUID =>
  axios.get(`${url.asu.pubPortal.sites}/${siteUUID}/article-sentiment-units/code`, {withCredentials});

export const getTestPage = ({articleSentimentUnitUUID, pageId}) =>
  `${url.asu.articleSentimentUnits}/${articleSentimentUnitUUID}/test-page/pageTitle${pageId ? `?pageId=${pageId}` : ''}`;

export const getMigrationStatus = articleSentimentUnitUUID =>
  axios.get(`${url.asu.pubPortal.articleSentimentUnits}/${articleSentimentUnitUUID}/migration-status`, {withCredentials});

export const setMigration = ({articleSentimentUnitUUID, migrationStatus}) =>
  axios.put(`${url.asu.articleSentimentUnits}/${articleSentimentUnitUUID}/migration-status`, {migrationStatus}, {withCredentials});
